import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { EntityOverview } from './EntityOverview';
import { EntityGraph } from './EntityGraph';

// Replaces the stock overview tab (entity-content:catalog/overview, disabled in
// app-config.yaml) with a structured layout: substance left, metadata right.
const overviewContent = EntityContentBlueprint.make({
  name: 'overview',
  params: {
    path: '/',
    title: 'Overview',
    // Without a group this lands after the plugin-contributed tabs; the
    // overview group is rendered first.
    group: 'overview',
    loader: async () => <EntityOverview />,
  },
});

// Dependency graph on its own tab, where it has room to be explored.
const graphContent = EntityContentBlueprint.make({
  name: 'dependencies',
  params: {
    path: '/dependencies',
    title: 'Dependencies',
    // Deliberately NOT in the 'overview' group: two contents in one group get
    // collapsed into a dropdown, which buries this. Ungrouped renders it as a
    // top-level tab alongside TechDocs/APIs.
    loader: async () => <EntityGraph />,
  },
});

export const entityOverviewModule = createFrontendModule({
  pluginId: 'app',
  extensions: [overviewContent, graphContent],
});
